import { render } from "./App.vue?vue&type=template&id=7588e5dc"
const script = {}

import "./App.vue?vue&type=style&index=0&id=7588e5dc&lang=css"
script.render = render

export default script